import React, { forwardRef, useEffect, useState } from 'react'
import { useFormatLocalizedNumber } from '@/lib/hooks/useLocaleFormatter'

export type FormattedInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> & {
  value: string | number
  onChange?: (value: string) => void
}

const FormattedInput = forwardRef<HTMLInputElement, FormattedInputProps>(({ value, onChange, ...props }, ref) => {
  const [focused, setFocused] = useState(false)
  const formatNumber = useFormatLocalizedNumber({ minimumFractionDigits: 2, maximumFractionDigits: 2 })

  const format = (val: string | number) => {
    const raw = val ?? ''
    const parsed = Number(String(raw).replace(/,/g, ''))
    if (Number.isFinite(parsed)) return formatNumber(parsed)
    return String(raw)
  }

  const displayed = focused ? String(value ?? '') : format(value)

  useEffect(() => {}, [value, focused])

  return (
    <input
      ref={ref}
      {...props}
      value={displayed ?? ''}
      onFocus={e => {
        setFocused(true)

        const raw = String(value ?? '')
        e.currentTarget.value = raw

        if (props.onFocus) props.onFocus(e)
      }}
      onBlur={e => {
        setFocused(false)
        if (props.onBlur) props.onBlur(e)
      }}
      onChange={e => {
        const v = e.target.value

        if (onChange) onChange(v)

        if ((props as any).onChange) (props as any).onChange(e)
      }}
    />
  )
})

FormattedInput.displayName = `FormattedInput`

export default FormattedInput
